export function uniqueSort(array: Date[]) {
  let arr = [...array];
  return arr.sort((a, b) => +a - +b).filter((x, i, a) => !i || +x !== +a[i - 1]);
}
